import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { layoutAsyncConnect } from 'utils/asyncConnectWrapper';

import { asyncConnectMostRead } from 'modules/Common/reducers/morenews';

import MostReadPanel from '../components/MostReadPanel';

@layoutAsyncConnect(
  "MostReadRacing",
  asyncConnectMostRead("/racing")
)
export default class MostReadRacing extends Component {
  static propTypes = {
    mostread: PropTypes.array
  };

  render() {
    return <MostReadPanel articles={this.props.mostread} title="Racing" />;
  }
}



// WEBPACK FOOTER //
// ./modules/Common/containers/MostReadRacing.js